<template>
    <div class="card" style="min-height: 200px">
        <div class="table-responsive action-table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th>Invoice No</th>
                    <th>Invoice Date</th>
                    <th>Patient Details</th>
                    <th>Consultant</th>
                    <th>Admission No</th>
                    <th>Word/Bed/Cabin</th>
                    <th>Unit</th>
                    <th class="text-right">Bill Amount</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in purchase" :key="i">
                    <td> {{ item.bill_number }}</td>
                    <td> {{ item.date }}</td>
                    <td style="width: 15%">
                        <p style="font-weight: bold">{{ item.party_name }}</p>
                        <p>{{getPartyInfo(item.contact, 'mobile_no')}}</p>
                    </td>
                    <td>
                        {{ item.ipd_register && item.ipd_register.human_resource && item.ipd_register.human_resource.name }}
                    </td>
                    <td> {{ item.ipd_register && item.ipd_register.admission_no }}</td>
                    <td>
                        {{ item.ipd_register && item.ipd_register.service_resource && item.ipd_register.service_resource.name }}
                    </td>
                    <td> {{ item.business && item.business.name }}</td>
                    <td class="text-right"> {{ item.bill_amount }}</td>
                    <td> {{ item.status }}</td>
                    <td>
                        <div class="d-flex">
                            <div class="dropdown">
                                <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-boundary="viewport">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end action-dropdown-menu">
                                    <li>
                                        <a class="dropdown-item" href="#" @click="goToPrint(item.id, 1)">
                                            <i class="fas fa-print me-2"></i> Print Invoice
                                        </a>
                                    </li>
                                    <li v-if="item.status !== 'returned'">
                                        <a class="dropdown-item" href="#" @click="goToEdit(item.id)">
                                            <i class="fas fa-pencil me-2"></i> Edit Invoice
                                        </a>
                                    </li>
                                    <li v-if="item.status === 'active'">
                                        <a class="dropdown-item" href="#" @click="goToReturn(item.id)">
                                            <i class="far fa-window-close me-2"></i> Return Invoice
                                        </a>
                                    </li>
                                    <li v-if="item.status !== 'returned'">
                                        <a class="dropdown-item" href="#" @click="goToPartialReturn(item.id)">
                                            <i class="fas fa-undo-alt me-2"></i> Partial Return Invoice
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="!purchase.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script>
import figureFormatter from '@/services/utils/figureFormatter';
import handlePurchase from "@/services/modules/purchase";
import pdfPrinter from '@/services/utils/pdfPrinter';
import handleCompany from "@/services/modules/company";
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import hospitalPdfPrinterHelper from "@/services/utils/hospitalPdfPrinterHelper";

export default {
    name: 'HospitalPharmacyListTable',
    data() {
        return{
            companyInfo: {},
            invoice: {},
            barcodeQuery: '',
            barcode: '',
            user: {},
            invoiceRes: {},
            qrcode: '',
            customizationPdfFields: {}
        }
    },
    props: {
        purchase: Array
    },
    setup() {
        const {commaFormat} = figureFormatter()
        const { fetchSalesBill } = handlePurchase();
        const {fetchCompanyInfo, fetchActiveCustomizationField} = handleCompany();
        const { exportToPDF } = pdfPrinter();
        const { fetchBarcode } = handleBarcode();
        const store = useStore();
        const { generatePdf } = hospitalPdfPrinterHelper();

        return {
            commaFormat,
            fetchSalesBill,
            exportToPDF,
            fetchCompanyInfo,
            fetchBarcode,
            generatePdf,
            store,
            fetchActiveCustomizationField
        }
    },
    async mounted() {
         this.fetchCompanyInfo(this.$route.params.companyId).then( (res) => {
            this.companyInfo = res.data;
         }).catch((error) => {
         });
         this.user = this.store.state.user.user
         await this.getActiveFiledCustomization();
    },
    methods: {
        async getActiveFiledCustomization() {
            const companyId = this.$route.params.companyId;
            const companyQuery = `?company_id=${companyId}&customization_type=pdf&type=pharmacy_bill_pdf`;
            const res = await this.fetchActiveCustomizationField(companyQuery);
            if (! res.status) return;
            this.customizationPdfFields = res.data;
        },
        goToPrint(id) {
            const companyId = this.$route.params.companyId
            const companyQuery = `?company_id=${companyId}`;

            this.fetchSalesBill(id, companyQuery).then( (res) =>{
                if( res ){
                    this.invoiceRes = res.data;
                }
            }).then( () => {
                this.generatePdf(this.companyInfo, this.invoiceRes, 'BILL', true, true, false, false,
                            this.customizationPdfFields && this.customizationPdfFields.heading_left_pos_print,
                            this.customizationPdfFields)
            }).catch( (err) => {
            })
        },
        getPartyInfo(contact, fieldName) {
            if (contact && contact.profile_items) {
                const field = contact.profile_items.find(item => item.field === fieldName)
                return field && field.value
            }
            return ""
        },
        goToReturn(id) {
            this.pushReturnRoute("ipd-bill-return", id);
        },
        goToPartialReturn(id) {
            this.pushReturnRoute("ipd-pharmacy-bill-partial-return", id);
        },
        pushReturnRoute(routeName, id) {
            const ipdRegisterId = this.$route.params.ipdRegisterId || this.$route.query.ipd_register_id;
            let params = {
                companyId: this.$route.params.companyId,
                moduleId: this.$route.params.moduleId,
                menuId: this.$route.params.menuId,
                pageId: this.$route.params.pageId,
                ipdRegisterId: ipdRegisterId,
                invoiceId: id
            };
            this.$router.push({
                name: routeName,
                params,
                query: {
                    ...this.$route.query,
                    tab: "ipd-bill",
                    sale_type: "ipd_pharmacy_invoice",
                    redirect_route: "ipd-pharmacy-bill-statement"
                }
            });
        },
        goToEdit(ipdId) {
            const ipdRegisterId = this.$route.params.ipdRegisterId || this.$route.query.ipd_register_id;

          let params = {
            companyId: this.$route.params.companyId,
            moduleId: this.$route.params.moduleId,
            menuId: this.$route.params.menuId,
            pageId: this.$route.params.pageId,
            ipdId: ipdId,
            ipdRegisterId: ipdRegisterId,
          }

          const query = {
              ...this.$route.query,
              redirect_route: this.redirect_route
          };
          if (this.$route.hash && this.$route.hash === '#billing') {
            query.back_url = encodeURIComponent(this.$route.fullPath);
          }

          this.$router.push({
            name: "ipd-pharmacy-bill-edit",
            params,
            query: query
          })
        }
    }
}
</script>

<style scoped>
.action-table-responsive {
    overflow: visible;
}
.action-dropdown-menu {
    position: absolute;
    z-index: 1055;
}
</style>
